import HttpService from './httpService';
import config from '../../config';

class LoginApiService extends HttpService {
  constructor(baseUrl, generalCatch) {
    super(baseUrl, generalCatch);
  }

  // `silent: true` (solo /mcp-login): el fallo se relanza sin el toast global,
  // que mostraría detalles técnicos. El resto de llamadas no cambia.
  async auth({ tokenId, profileObj }, { silent = false } = {}) {
    const body = { tokenId, profileObj };
    return silent ? this.post('auth', body, { silent: true }) : this.post('auth', body);
  }
}

const loginApiService = new LoginApiService(config.REACT_APP_NODE_API);
export default loginApiService;
